import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map } from 'rxjs/operators'
import { saleItemActions } from '../sale-item/sale-item.actions'
import { saleItemSurveyDraftActions } from './sale-item-survey-draft.actions'

@Injectable()
export class SaleItemSurveyDraftEffects {
  constructor(private actions$: Actions) {}

  removeDraftOnPartialDelete = createEffect(() =>
    this.actions$.pipe(
      ofType(saleItemActions.removeOnePartial),
      map(({ id }) =>
        saleItemSurveyDraftActions.removeBySaleItemId({ saleItemId: id })
      )
    )
  )

  resetDraftsOnPartialReset = createEffect(() =>
    this.actions$.pipe(
      ofType(saleItemActions.resetPartials),
      map(() => saleItemSurveyDraftActions.resetState())
    )
  )
}
